<template>
  <main class="ps-page ps-page--blog">
    <div class="ps-page__header bg--cover" v-if="key !== 'all' && key !== ''" :style="{backgroundImage: `url('static/img/blog/`+key+`-bg.jpg')`}" style="background-size: cover; background-position: center;">
      <div class="container">
        <h1 class="text-uppercase">{{ getTextByLang(category, 'category', lang) }}</h1>
      </div>
    </div>
    <div class="ps-page__header bg--cover" v-else :style="{backgroundImage: `url('static/img/blog/all-bg.jpg')`}" style="background-size: cover; background-position: center;">
      <div v-if="key === 'all'">
        <h1 class="text-uppercase" v-if="lang === 'es'">Todas las publicaciones</h1>
        <h1 class="text-uppercase" v-else>All posts</h1>
      </div>
      <div v-else>
        <h1 class="text-uppercase" v-if="lang === 'es'">Categoria no encontrada</h1>
        <h1 class="text-uppercase" v-else>Category not found</h1>
      </div>
    </div>
    <div class="container">
      <section class="ps-blog--sidebar false">
        <div class="ps-section__left">
          <div class="ps-section__items">
            <div class="ps-blog--post-items">
              <div class="row">
                <div class="col-2 col-sm-6 col-12" v-for="post in posts" v-bind:key="post._id">
                  <article class="ps-post ps-post--grid">
                    <div class="ps-post__thumbnail">
                      <a :href="'/blog/'+post.key" class="ps-post__overlay"></a>
                      <img :src="post.image || defaultBanner" :alt="getTextByLang(post, 'title', lang)">
                    </div>
                    <div class="ps-post__content">
                      <div class="ps-post__categories">
                        {{ getTextByLang(category, 'category', lang) }}
                      </div>
                      <h4 class="ps-post__title">
                        <a :href="'/blog/'+post.key" class="">
                          {{ getTextByLang(post, 'title', lang) }}
                        </a>
                      </h4>
                      <div class="ps-post__meta">
                          <div class="ps-post__author">
                            <div class="ps-post__author-img">
                              <img :src="post.author.profile_image" :alt="getAuthor(post)">
                            </div>
                            <div class="ps-post__author-name">
                              <a href="#">
                                {{ getAuthor(post) }}
                              </a>
                            </div>
                          </div>
                          <span class="ps-post__posted">{{ moment.utc(post.publishing_date).format('LL') }}</span>
                      </div>
                      <div class="ps-post__short-desc">
                        <p>{{ getTextByLang(post, 'description', lang) }}</p>
                      </div>
                      <div class="ps-post__footer">
                        <a :href="'/blog/'+post.key" class="ps-post__morelink effect--underline">
                          <span v-if="lang === 'es'">Leer más</span>
                          <span v-else>Reading More</span>
                        </a>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </div>
          <div class="ps-section__pagination ps-loadmore">
            <div class="m-t-sm btn-group pull-right" v-if="!loading">
              <router-link :to="`/blog/category/${key}?page=`+(getPreviousPage() + 1)" class="effect--underline pr-3" :disabled="currentPage == 1">
                <i class="fa fa-chevron-left"></i>
                <span class="ml-1" v-if="isCrawler">
                  <span v-if="lang === 'es'">P&aacute;gina anterior</span>
                  <span v-else>Previous Page</span>
                </span>
              </router-link>
              <a href="javascript:void(0)" class="effect--underline">
                <span v-if="lang === 'es'">P&aacute;gina</span>
                <span v-else>Page</span>
                {{ currentPage + 1 }}
                <span v-if="lang === 'es'">de</span>
                <span v-else>of</span>
                {{ getTotalPages() }}
              </a>
              <router-link :to="`/blog/category/${key}?page=`+getNextPage()"  class="effect--underline pl-3" :disabled="currentPage >= getTotalPages()">
                <span class="mr-1" v-if="isCrawler">
                  <span v-if="lang === 'es'">Siguiente P&aacute;gina</span>
                  <span v-else>Next Page</span>
                </span>
                <i class="fa fa-chevron-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="ps-section__right">
          <SideWidget :lang="lang" :moment="moment" :allPosts="allPosts" :totalNonCategoryPost="totalNonCategoryPost" :categories="categories"></SideWidget>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import Blog from '../../services/blog'
import Filters from '../utils/filters'
import SideWidget from './SideWidget'
import moment from 'moment'
import _ from 'underscore'
export default {
  name: 'BlogCategory',
  data () {
    return {
      defaultImage: '/static/img/img-placeholder.jpg',
      defaultBanner: '/static/img/blog/default-banner.jpg',
      lang: 'en',
      posts: [],
      allPosts: [],
      category: {},
      categories: [],
      moment: moment,
      key: '',
      totalNonCategoryPost: 0,
      loading: true,
      searchLimit: 4,
      currentPage: 0,
      totalResults: 0,
      isCrawler: false
    }
  },
  methods: {
    getAuthor: function (item) {
      let name = ''
      if (!item.author) {
        return 'Indiefy'
      }
      if (item.author.name) {
        name = item.author.name
        if (item.author.last_name) {
          name += ' ' + item.author.last_name
        }
      } else {
        name = item.author.username
      }
      return name
    },
    getPreviousPage: function () {
      if (this.currentPage > 0) {
        return this.currentPage - 1
      } else {
        return 0
      }
    },
    getNextPage: function () {
      if ((this.currentPage + 1) >= this.getTotalPages()) {
        return this.getTotalPages()
      } else {
        return this.currentPage + 2
      }
    },
    getTotalPages: function () {
      return Math.ceil(this.totalResults / this.searchLimit) || '1'
    },
    getPosts: function () {
      let filter = {
        limit: this.searchLimit,
        page: this.currentPage + 1
      }

      this.loading = true

      Blog.getPostByCategory(this.key, filter).then(response => {
        this.category = response.data.category
        if (response.data.posts.length) {
          this.posts = response.data.posts
          this.totalResults = response.data.total
          this.loading = false
        }
        setTimeout(() => {
          window.prerenderReady = true
        })
      })
    },
    getTextByLang: Filters.getTextByLang
  },
  watch: {
    $route: function () {
      if (this.$route.query.page) {
        this.currentPage = parseInt(this.$route.query.page) - 1
      } else {
        this.currentPage = 1
      }
      this.getPosts()
    }
  },
  created: function () {
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)
    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    if (this.$route.query.lang) {
      this.lang = this.$route.query.lang
    }

    if (this.$route.params.key) {
      this.key = this.$route.params.key
    }

    this.loading = true
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page) - 1
    }

    this.getPosts()

    Blog.getCategoryAndTotals().then(response => {
      this.categories = response.data.categories
      this.totalNonCategoryPost = response.data.total_non_category_blogs
      _.each(response.data.categories, elem => {
        this.totalNonCategoryPost = this.totalNonCategoryPost + elem.total_blogs
      })
    })

    Blog.getAll({
      limit: 9,
      page: 1
    }).then(response => {
      this.allPosts = response.data.items
    })
  },
  components: {
    SideWidget
  }
}
</script>
<style lang="scss" scoped>
@import "../../../static/fonts-blog/font-awesome/css/font-awesome.css";
@import "../../assets/sass/blog/vars.scss";
@import "../../assets/sass/blog/v-grid.scss";
@import "../../assets/sass/blog/iconfont.scss";
@import "../../assets/sass/blog/button.scss";
@import "../../assets/sass/blog/v-list-group.scss";
@import "../../assets/sass/blog/list.scss";
@import "../../assets/sass/blog/application.scss";
@import "../../assets/sass/blog/v-list.scss";
@import "../../assets/sass/blog/v-icon.scss";
@import "../../assets/sass/blog/pages.scss";
@import "../../assets/sass/blog/header.scss";
@import "../../assets/sass/blog/attraction.scss";
@import "../../assets/sass/blog/section.scss";
@import "../../assets/sass/blog/block.scss";
/* @import "../../assets/sass/blog/post.scss"; */
@import "../../assets/sass/blog/form.scss";
@import "../../assets/sass/blog/widget.scss";
@import "../../assets/sass/blog/footer.scss";
</style>



// WEBPACK FOOTER //
// src/components/blog-components/BlogCategory.vue